export const CREATE_SLIDER_REQUEST = "CREATE_SLIDER_REQUEST";
export const CREATE_SLIDER_SUCCESS = "CREATE_SLIDER_SUCCESS";
export const CREATE_SLIDER_FAIL = "CREATE_SLIDER_FAIL";

export const FETCH_SLIDER_REQUEST = "FETCH_SLIDER_REQUEST";
export const FETCH_SLIDER_SUCCESS = "FETCH_SLIDER_SUCCESS";
export const FETCH_SLIDER_FAIL = "FETCH_SLIDER_FAIL";

export const DELETE_SLIDER_REQUEST = "DELETE_SLIDER_REQUEST";
export const DELETE_SLIDER_SUCCESS = "DELETE_SLIDER_SUCCESS";
export const DELETE_SLIDER_FAIL = " DELETE_SLIDER_FAIL";

export const SHOW_SLIDER_REQUEST = "SHOW_SLIDER_REQUEST";
export const SHOW_SLIDER_SUCCESS = "SHOW_SLIDER_SUCCESS";
export const SHOW_SLIDER_FAIL = " SHOW_SLIDER_FAIL";

export const UPDATE_SLIDER_REQUEST = "UPDATE_SLIDER_REQUEST";
export const UPDATE_SLIDER_SUCCESS = "UPDATE_SLIDER_SUCCESS";
export const UPDATE_SLIDER_FAIL = " UPDATE_SLIDER_FAIL";
